<template>
  <div>
    <list
      row-key="LogId"
      ref="list"
      unit="操作日志"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.list"
      :delete-func="api.delete"
      @reset="reset"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="用户名称">
          <el-input   v-model="params.UserName" placeholder="请填写用户名称" clearable />
        </el-form-item>
        <el-form-item label="所属组织">
          <tree-select
            ref="treeSelect"
             
            :props="props"
            :options="TreeData"
            :value="params.DpId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect($event)"
          />
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker
            v-model.trim="params.StartTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
          -
          <el-date-picker
            v-model.trim="params.EndTime"
            placeholder="请选择日期"
            value-format="yyyy-MM-dd"
            style="width: 193px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="操作模块">
          <tree-select
            ref="treeSelect2"
            :props="props2"
            :options="MenuData"
            :value="MenuId"
            :clearable="true"
            :accordion="true"
            :parentSelect="true"
            placeholder="请选择"
            @node-select="onTreeSelect2($event)"
          />
        </el-form-item>
        <el-form-item label="操作类型">
          <!-- <el-select v-model="params.OperType" filterable allow-create   clearable>
            <el-option value="添加" />
            <el-option value="修改" />
            <el-option value="删除" />
          </el-select> -->
          <el-autocomplete v-model="params.OperType" :fetch-suggestions="querySearch" clearable placeholder="请填写操作类型" />
        </el-form-item>
        <el-form-item label="信息标识">
          <el-input   v-model="params.Title" placeholder="请填写信息标识" clearable/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="UserName" label="用户名称" />
        <el-table-column prop="DpName" label="所属组织" />
        <el-table-column prop="AddTime" label="操作时间"  width="140px"/>
        <el-table-column prop="MenuName" label="操作模块" width="150px" />
        <el-table-column prop="OperType" label="操作类型" width="100px"/>
        <el-table-column prop="Title" label="信息标识" show-overflow-tooltip />
        
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
import list from "@/components/common/list";
import listMixin from "@/mixins/list";
import treeSelect from "@/components/common/treeSelect";

export default {
  mixins: [listMixin],
  components: { list,treeSelect },
  beforeMount() {
    var obj = {};
    if(loginInfo.UserType==1) {
      obj.FirstId = loginInfo.FirstId;
    }
    this.dpApi.getAuthList(obj).then((res) => {
      this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
    })
    this.api.getModules().then(res => {
      var arr = [];
      var id = 1
      res.forEach((e,i) => {
        var obj = { MenuName: e.ModuleName, MenuId: id, Pid: 0 };
        id++;
        arr.push(obj);
        e.MenuNames.forEach((n,m) => {
          arr.push({
            MenuName: n,
            MenuId: id,
            Pid: obj.MenuId,
          })
          id++;
        })
      });
      this.MenuData = this.$commonJs.toTreeData(arr, "MenuId");
    })
  },
  data() {
    return {
      api: require("@/api/sy/log").default,
      dpApi: require("@/api/basic/dp").default,
      params: {
        Module: "",
        UserName: "",
        StartTime: null,
        EndTime: null,
        MenuName: "",
        KeyWord: "",
        DpId: null,
        OperType: null
      },
      MenuId: null,
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      props2: {
        value: "MenuId",
        label: "MenuName",
        children: "children",
      },
      TreeData: [],
      MenuData: [],
    };
  },
  methods: {
    onTreeSelect(t) {
      if (!t) {
        this.params.DpId = null;
      } else {
        this.params.DpId = t.DpId;
      }
    },
    onTreeSelect2(t) {
      if (!t) {
        this.MenuId = null;
        this.params.MenuName = "";
        this.params.ModuleName = "";
      } else if(t.Pid) {
        this.MenuId = t.MenuId;
        this.params.MenuName = t.MenuName;
        this.params.ModuleName = "";
      } else {
        this.MenuId = null;
        this.params.MenuName = "";
        this.params.ModuleName = t.MenuName;
      }
    },
    querySearch(queryString, cb) {
      var restaurants = [
        {value: "添加"},
        {value: "修改"},
        {value: "删除"},
      ];
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    reset() {
      this.$refs.treeSelect.clearHandle();
      this.$refs.treeSelect2.clearHandle();
    },
  }
};
</script>